import { useTranslation } from 'react-i18next';

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function CertificationSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-accent-500/[0.03] rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent-500/[0.02] rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>
      <div className="relative z-10 max-w-[800px] mx-auto px-8 text-center">
        {renderParagraphs(
          t('coursesMaster.cert.label'),
          'text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label'
        )}
        <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-4">
          {t('coursesMaster.cert.title')}
        </h2>
        <div className="gold-line mx-auto mb-6"></div>
        {renderParagraphs(
          t('coursesMaster.cert.titleEn'),
          'section-title-en text-accent-400/50 text-sm tracking-[0.12em] mb-8'
        )}
        {renderParagraphs(
          t('coursesMaster.cert.description'),
          'text-[17px] text-foreground-300 leading-relaxed tracking-[0.04em] mb-10 max-w-xl mx-auto'
        )}
        <div className="inline-block border border-accent-500/30 bg-accent-500/[0.04] px-10 py-7 mb-6">
          {renderParagraphs(
            t('coursesMaster.cert.qualLabel'),
            'text-[13px] text-accent-400/60 tracking-[0.15em] mb-3 font-label'
          )}
          {renderParagraphs(
            t('coursesMaster.cert.qualification'),
            'font-heading text-[17px] text-accent-300 tracking-[0.06em] leading-relaxed mb-2'
          )}
          <p className="text-[14px] text-foreground-400 tracking-[0.05em]">
            + {t('coursesMaster.cert.badge')}
          </p>
        </div>
        {renderParagraphs(
          t('coursesMaster.cert.note'),
          'text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed'
        )}
      </div>
    </section>
  );
}
